
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { RoomObject } from '@/utils/models';

@Component({ components: {} })
export default class Board extends Vue {
  @Prop() roomObject!: RoomObject;

  get imageBase64(): string {
    return this.roomObject.imageBase64;
  }
  get width(): number {
    return this.roomObject.width ? this.roomObject.width : 1;
  }
  get height(): number {
    return this.roomObject.size ? this.roomObject.size : 1;
  }
  get fontSize(): number {
    return +(this.roomObject.props.fontSize ?? 10);
  }
  get content(): string {
    return this.roomObject.props.content;
  }
  get tooltip(): string {
    return this.roomObject.props.tooltip;
  }
  get isLocked(): boolean {
    return this.roomObject.isLocked ?? false;
  }
  get boardType(): 'fusen' | 'message' {
    return this.roomObject.props.boardType as 'fusen' | 'message';
  }
  get backgroundColor(): string {
    return this.roomObject.props.backgroundColor;
  }
  get color(): string {
    return this.roomObject.props.color;
  }
  get borderColor(): string {
    return this.roomObject.props.borderColor;
  }
  get borderBottomColor(): string {
    return this.roomObject.props.borderBottomColor;
  }
  get textAlignHorizontal(): string {
    switch (this.roomObject.props.textAlignHorizontal) {
      case 'left':
      default:
        return 'left';
      case 'center':
        return 'center';
      case 'right':
        return 'right';
    }
  }
  get textAlignVertical(): string {
    switch (this.roomObject.props.textAlignVertical) {
      case 'top':
      default:
        return 'flex-start';
      case 'center':
        return 'center';
      case 'bottom':
        return 'flex-end';
    }
  }
}
